/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { candidateSchema } from './candidate-schema';
import { CustomTalentAlertType } from "../enums";
export const userCustomTalentAlertSchema: z.AnyZodObject = z.object({
  alertActive: z.boolean(),
  alertType: z.nativeEnum(CustomTalentAlertType).nullish(),
  candidate: z.lazy(() => candidateSchema).nullish(),
  candidateId: z.string().uuid().nullish(),
  createdAt: z.string().datetime().nullish(),
  id: z.string().uuid(),
  minAvailability: z.number().int().nullish(),
  updatedAt: z.string().datetime().nullish(),
  userId: z.string().uuid().nullish(),
});

export type UserCustomTalentAlert = z.infer<typeof userCustomTalentAlertSchema>;
